<template>
	<div class="page">
	  <div class="app-container">
		<el-button type="primary" @click="dialogVisible = true">新增</el-button>
		<el-table :data="tempList" style="width: 100%">
		  <el-table-column prop="id" label="ID"></el-table-column>
		  <el-table-column prop="company" label="报价公司"></el-table-column>
		  <el-table-column prop="company_logo" label="logo">
			<template slot-scope="scope">
			  <img :src="scope.row.company_logo" alt="" class="img_size">
			</template>
		  </el-table-column>
		  <el-table-column prop="company_watermark" label="水印">
			<template slot-scope="scope">
			  <img :src="scope.row.company_watermark" alt="" class="img_size">
			</template>
		  </el-table-column>
		  <el-table-column prop="official_seal" label="公章">
			<template slot-scope="scope">
			  <img :src="scope.row.official_seal" alt="" class="img_size">
			</template>
		  </el-table-column>
		  <el-table-column label="操作">
			<template slot-scope="scope">
			  <el-button
				size="mini"
				@click="handleEdit(scope.$index, scope.row)">编辑</el-button>
			  <el-popconfirm
				title="确定删除吗？"
				@confirm="handleDelete(scope.$index, scope.row)"
			  >
				<el-button size="mini" type="danger" slot="reference" style="margin-left: 10px;">删除</el-button>
			  </el-popconfirm>
			</template>
		  </el-table-column>
		</el-table>
  
		<el-dialog
		  title="模板编辑"
		  :visible.sync="dialogVisible"
		  @close="handleClose"
		  width="50%">
		  <el-form
			:model="formData"
			inline
			ref="baseForm"
			label-width="80px"
		  >
			<el-form-item class="from-item--30" label="报价公司" prop="company">
			  <el-input
				type="input"
				v-model="formData.company"
				placeholder="请输入报价公司"
			  ></el-input>
			</el-form-item>
			<br />
			<el-form-item class="from-item--30" label="logo" prop="company_logo">
			  <el-upload
				class="avatar-uploader"
				:action="$settings.uploadUrl.img + '/admin/upload/upimg'"
				name="img"
				:show-file-list="false"
				:headers="{
				  token: getToken(),
				}"
				:data="{
				  path: 20,
				}"
				:on-success="(res) => uploadImgSuccess(res, 'company_logo')"
			  >
				<img
				  v-if="formData.company_logo"
				  :src="formData.company_logo"
				  class="avatar"
				/>
				<i v-else class="el-icon-plus avatar-uploader-icon"></i>
			  </el-upload>
			</el-form-item>
			<br />
			<el-form-item
			  class="from-item--30"
			  label="水印"
			  prop="company_watermark"
			>
			  <el-upload
				class="avatar-uploader"
				:action="$settings.uploadUrl.img + '/admin/upload/upimg'"
				name="img"
				:show-file-list="false"
				:headers="{
				  token: getToken(),
				}"
				:data="{
				  path: 20,
				}"
				:on-success="(res) => uploadImgSuccess(res, 'company_watermark')"
			  >
				<img
				  v-if="formData.company_watermark"
				  :src="formData.company_watermark"
				  class="avatar"
				/>
				<i v-else class="el-icon-plus avatar-uploader-icon"></i>
			  </el-upload>
			</el-form-item>
			<br />
			<el-form-item class="from-item--30" label="公章" prop="official_seal">
			  <el-upload
				class="avatar-uploader"
				:action="$settings.uploadUrl.img + '/admin/upload/upimg'"
				name="img"
				:show-file-list="false"
				:headers="{
				  token: getToken(),
				}"
				:data="{
				  path: 20,
				}"
				:on-success="(res) => uploadImgSuccess(res, 'official_seal')"
			  >
				<img
				  v-if="formData.official_seal"
				  :src="formData.official_seal"
				  class="avatar"
				/>
				<i v-else class="el-icon-plus avatar-uploader-icon"></i>
			  </el-upload>
			</el-form-item>
  
			<div class="confirm">
			  <el-button type="primary" @click="submit">提交</el-button>
			  <el-button type="info" @click="resetInfo">重置</el-button>
			</div>
		  </el-form>
		</el-dialog>
		
	  </div>
	</div>
  </template>
  
  <script>
  import { getToken } from "@/utils/auth";
  import { columns } from "./columns";
  
  export default {
	name: "quotation",
	comments: {},
	data() {
	  return {
		formData: {
		  company: "",
		  company_logo: "",
		  company_watermark: "",
		  official_seal: "",
		},
		tempList: [],
		dialogVisible: false
	  };
	},
	computed: {columns},
	created() {
	  // this.getDetail();
	  this.getTempList();
	},
	methods: {
	  getToken,
	  getTempList(){
		this.$api.post("/admin/companyQuotation/index", {}).then((res) => {
		  if (res.data) {
			this.tempList = res.data.data;
		  }
		});
	  },
	  // 上传图片成功后
	  uploadImgSuccess(res, key) {
		if (key == "company_logo") {
		  this.formData.company_logo = res.data.path;
		}
		if (key == "official_seal") {
		  this.formData.official_seal = res.data.path;
		}
		if (key == "company_watermark") {
		  this.formData.company_watermark = res.data.path;
		}
	  },
	  // 图片上传之前
	  beforeUpload(file) {},
	  // 提交表单
	  async submit() {
		const data = this.formData;
		if(!this.formData.company) {
		  return this.$message.error("请输入报价公司");
		}
		let res = await this.$api.post(
		  "/admin/companyQuotation/save",
		  {
			id: data.id,
			company: data.company,
			company_logo: data.company_logo, 
			company_watermark: data.company_watermark,
			official_seal: data.official_seal,
		  },
		  "报价单设置"
		);
		
		if(res) {
		  this.dialogVisible = false
		  this.getTempList();
		}
	  },
	  // 重置表单
	  async resetInfo() {
		const res = await this.$confirm("重置将会清空您填的数据，是否确认？");
		if (res !== "confirm") return;
		this.formData = {
		  id: '',
		  company: "",
		  company_logo: "",
		  company_watermark: "",
		  official_seal: "",
		};
	  },
	  async handleEdit(index,row) {
		this.formData = row
		this.dialogVisible = true
	  },
	  handleClose(){
		this.formData = {
		  id: '',
		  company: "",
		  company_logo: "",
		  company_watermark: "",
		  official_seal: "",
		};
	  },
  
	  async handleDelete(index,row) {
		let res = await this.$api.post("/admin/companyQuotation/del", {id:row.id},"报价单模版删除")
		this.getTempList();
	  }
	},
  };
  </script>
  <style>
  .avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
	border-color: #409eff;
  }
  .avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 150px;
	height: 150px;
	line-height: 150px;
	text-align: center;
  }
  .avatar {
	width: 150px;
	height: 150px;
	display: block;
  }
  .confirm {
	margin-top: 20px;
	margin-left: 70px;
  }
  .img_size {
	width: 100px;
  }
  </style>
  